import React, { FC } from 'react';
import { Redirect } from 'react-router-dom';

type IMobileRedirect = {
	isNewPlatformEnabled: boolean;
	redirectTo: string;
	router: JSX.Element;
};

export const MobileRedirect: FC<IMobileRedirect> = ({
	isNewPlatformEnabled,
	redirectTo,
	router
}) => {
	if (isNewPlatformEnabled) {
		return router;
	}

	return <Redirect to={redirectTo} />;
};
